import React from "react";
import styled, { keyframes } from "styled-components";

const Loading = () => (
  <Container>
    <Spinner />
  </Container>
);

export default Loading;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: white;
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #e0e0e0;
  border-top-color: #999;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
